// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/keen-slider/keen-slider.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  background: white;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* body > iframe {
  display: none!important;
} */

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.ant-card-head{
  border-bottom: 0px solid white!important;
}

.anticon-close {
  color: white !important;
}

.ant-menu {
  background-color: #040724 !important;
  color: whitesmoke !important;
}

.ant-menu-item-icon {
  color: whitesmoke !important;
}
.ant-menu-title-content {
  color: whitesmoke !important;
  font-weight: 600 !important;
}
.ant-layout-sider{
  background: #040724!important;
}
.ant-menu-item-selected {
  background-color: #36c6d3 !important;
  font-weight: 600 !important;
}
.ant-menu-submenu-arrow {
  color: #fefefe !important;
}

.ant-table-cell-row-hover {
  background: #eceff1 !important;
}

.ant-menu.ant-menu-inline-collapsed {
  max-width: 100px !important;
}
/* Keep spacing same as AntD grid */
.slick-slide {
  padding: 0 12px; /* adjust like gutter */
}

.slick-list {
  margin: 0 -12px; /* prevent extra spacing */
}

/* Prevent slick arrows from breaking layout */
.slick-prev, .slick-next {
  z-index: 2;
}

@media (max-width: 700px) {
  .ant-layout-sider {
    display: none !important; /* Make sure it's hidden */
  }
  .header_btn {
    display: none !important;
  }
  .mobile_toggle {
    display: block !important; /* Show mobile toggle icon */
  }
  .ant-drawer .ant-drawer-content {
    background-color: #040724 !important;
  }
}

#chat-widget > div[style*="position: fixed"][style*="right: 1rem"] {
  right: 5rem !important;
}

.keen-slider__slide {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,SAAS;EACT,iBAAiB;EACjB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;GAEG;;AAEH;EACE;aACW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;AACA,mCAAmC;AACnC;EACE,eAAe,EAAE,uBAAuB;AAC1C;;AAEA;EACE,eAAe,EAAE,0BAA0B;AAC7C;;AAEA,8CAA8C;AAC9C;EACE,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB,EAAE,0BAA0B;EACtD;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import \"keen-slider/keen-slider.min.css\";\n\n\n\nbody {\n  margin: 0;\n  background: white;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/* body > iframe {\n  display: none!important;\n} */\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.ant-card-head{\n  border-bottom: 0px solid white!important;\n}\n\n.anticon-close {\n  color: white !important;\n}\n\n.ant-menu {\n  background-color: #040724 !important;\n  color: whitesmoke !important;\n}\n\n.ant-menu-item-icon {\n  color: whitesmoke !important;\n}\n.ant-menu-title-content {\n  color: whitesmoke !important;\n  font-weight: 600 !important;\n}\n.ant-layout-sider{\n  background: #040724!important;\n}\n.ant-menu-item-selected {\n  background-color: #36c6d3 !important;\n  font-weight: 600 !important;\n}\n.ant-menu-submenu-arrow {\n  color: #fefefe !important;\n}\n\n.ant-table-cell-row-hover {\n  background: #eceff1 !important;\n}\n\n.ant-menu.ant-menu-inline-collapsed {\n  max-width: 100px !important;\n}\n/* Keep spacing same as AntD grid */\n.slick-slide {\n  padding: 0 12px; /* adjust like gutter */\n}\n\n.slick-list {\n  margin: 0 -12px; /* prevent extra spacing */\n}\n\n/* Prevent slick arrows from breaking layout */\n.slick-prev, .slick-next {\n  z-index: 2;\n}\n\n@media (max-width: 700px) {\n  .ant-layout-sider {\n    display: none !important; /* Make sure it's hidden */\n  }\n  .header_btn {\n    display: none !important;\n  }\n  .mobile_toggle {\n    display: block !important; /* Show mobile toggle icon */\n  }\n  .ant-drawer .ant-drawer-content {\n    background-color: #040724 !important;\n  }\n}\n\n#chat-widget > div[style*=\"position: fixed\"][style*=\"right: 1rem\"] {\n  right: 5rem !important;\n}\n\n.keen-slider__slide {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
